<cc-top-bar [title]="'MENU.WIDGET'"></cc-top-bar>
<router-outlet></router-outlet>
